import * as tslib_1 from "tslib";
import { Pipe, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
var CurrentLangPipe = /** @class */ (function () {
    function CurrentLangPipe(cookieService) {
        this.cookieService = cookieService;
        this._langs = ['ru', 'kk', 'en'];
    }
    CurrentLangPipe.prototype.transform = function (descriptor) {
        var currentlocale = this.obtain();
        if ((currentlocale == null) || (this._langs.indexOf(currentlocale) < 0)) {
            return this.set('ru');
        }
        return currentlocale;
    };
    CurrentLangPipe.prototype.next = function () {
        var currentlocale = this.obtain();
        if ((currentlocale == null) || (this._langs.indexOf(currentlocale) < 0)) {
            return Promise.resolve(this.set('ru'));
        }
        return Promise.resolve(currentlocale);
    };
    CurrentLangPipe.prototype.get = function () {
        var currentlocale = this.obtain();
        if ((currentlocale == null) || (this._langs.indexOf(currentlocale) < 0)) {
            return this.set('ru');
        }
        return currentlocale;
    };
    CurrentLangPipe.prototype.changeTo = function (to) {
        return Promise.resolve(this.set(to));
    };
    CurrentLangPipe.prototype.obtain = function () {
        try {
            var _obtained = atob(this.cookieService.get('.AspNetCore.SecurityModule.' + btoa('currentlocale').replace('==', '')));
            return _obtained;
        }
        catch (err) {
            return this.set('ru');
        }
    };
    CurrentLangPipe.prototype.set = function (to) {
        this.cookieService.set('.AspNetCore.SecurityModule.' + btoa('currentlocale').replace('==', ''), btoa(to));
        return to;
    };
    CurrentLangPipe = tslib_1.__decorate([
        Pipe({
            name: 'currentLang'
        }),
        Injectable({
            providedIn: 'root'
        }),
        tslib_1.__metadata("design:paramtypes", [CookieService])
    ], CurrentLangPipe);
    return CurrentLangPipe;
}());
export { CurrentLangPipe };
//# sourceMappingURL=CurrentLangPipe.js.map